module.exports = __webpack_public_path__ + "img/icon_512x512.7d88adf.png";